export default {
	title: '模型计算模式',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		start: '启动',
		stop: '停止'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		operateSuccess: '操作成功',
		setSuccess: '设置成功',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	form: {
		md: '模型大类',
		mdcode: '模型大类编码',
		mversion: '版本',
		mm: '模型小类',
		mmcode: '模型小类编码',
		mdesc: '故障描述',
		mDCode: '模型大类',
		placeholder: {
			md: '请输入模型大类',
			mdcode: '请输入模型大类编码',
			mversion: '请输入版本',
			mm: '请输入模型小类',
			mmcode: '请输入模型小类编码',
			mdesc: '请输入故障描述',
			mDCode: '请输入模型大类'
		}
	},
	table: {
		md: '模型大类',
		mdcode: '模型大类代码',
		mm: '模型小类',
		mmcode: '模型小类代码',
		mtype: '模型类型',
		isEnable: '是否启用',
		mdesc: '故障描述',
		mversion: '版本'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定'
	},
	gridLayout: '格栅布局'
}
